import React, { useMemo } from 'react';
import { getRootUrl } from '@utils/urlHelpers.util';
import { Flex } from '@components/Flex';
import {
  GridContainer,
  ItemPerLine,
  GridItem,
  GridItemContainer,
  ProductTile,
  ImageWrapper,
  ImageContainer,
  ProductPhoto,
  StyledFlex,
  BrandText,
  TitleText,
  ItemWrapper,
} from './GridView.styles';
import { addRendition } from '@utils/photoRendition';
import { Integrations } from '@static/js/types';
const analytics = require('/static/js/joy');

export enum StoreFront {
  wedding = 'wedding',
  baby = 'baby',
}
export interface RecommendProduct {
  eventName: string;
  storeFront: StoreFront;
  node: {
    catalogItemGroupData: {
      tileViewItem: {
        id: string;
        title: string;
        publicUrlPath: string;
        brand: {
          name: string;
          publicUrlPath?: string;
        };
        photos?: {
          url: string;
        }[];
        mediaAssets?: {
          photo?: {
            url: string;
          };
        }[];
      };
    };
  };
  enabledAmplitude?: boolean;
}
[];

export type RecommendProducts = RecommendProduct[];

const ListItem: React.FC<RecommendProduct> = ({ node, eventName, storeFront, enabledAmplitude = false }) => {
  const { id, title, publicUrlPath, brand, photos, mediaAssets } = node.catalogItemGroupData.tileViewItem;
  const url = useMemo(() => (photos ? photos?.[0]?.url : mediaAssets?.[0]?.photo?.url), [mediaAssets, photos]);
  const shopUrl = useMemo(() => `${publicUrlPath}${storeFront === StoreFront.baby ? '?shopStorefront=baby' : ''}`, [
    publicUrlPath,
    storeFront,
  ]);

  const handleOnClick = () => {
    analytics.segment.sendTelemetryEvent(eventName, { name: title, value: shopUrl }, undefined, {
      integrations: { [Integrations.Amplitude]: enabledAmplitude },
    });
  };

  return (
    <>
      {url && (
        <ItemWrapper>
          <GridItem
            onClick={handleOnClick}
            forwardedAs="a"
            href={getRootUrl(shopUrl)}
            id={`GridItemLink${id}`}
            aria-label={`${brand.name} ${title}`}
            target="_blank"
          >
            <GridItemContainer>
              <ProductTile>
                <Flex flexDirection="column">
                  <ImageWrapper backgroundColor="white" justifyContent="center" alignItems="center">
                    <ImageContainer justifyContent="center" alignItems="center">
                      <ProductPhoto justifyContent="center" background={addRendition({ url, renditionSize: 'medium', isProduct: true })} />
                    </ImageContainer>
                  </ImageWrapper>
                  <StyledFlex flexDirection="column" alignItems="center" marginTop={5} justifyContent="start">
                    <BrandText color="mono1" variant="dek20" tagName="h3" textAlign="center">
                      {brand.name}
                    </BrandText>
                    <TitleText color="mono1" variant="dek20" tagName="h3" textAlign="center" data-title="Ramesh">
                      {title}
                    </TitleText>
                  </StyledFlex>
                </Flex>
              </ProductTile>
            </GridItemContainer>
          </GridItem>
        </ItemWrapper>
      )}
    </>
  );
};

interface GridViewProps {
  items: RecommendProducts;
  itemPerLine: ItemPerLine;
  eventName: string;
  storeFront: StoreFront;
  enabledAmplitude?: boolean;
}

export const GridView: React.FC<GridViewProps> = ({ items, itemPerLine, ...restProps }) => {
  return (
    <GridContainer itemPerLine={itemPerLine} marginX="auto">
      {items.map((item, index) => {
        return (
          item.node.catalogItemGroupData &&
          item.node.catalogItemGroupData.tileViewItem && (
            <ListItem key={item.node.catalogItemGroupData.tileViewItem?.title || '' + index} {...item} {...restProps} />
          )
        );
      })}
    </GridContainer>
  );
};
